import { createReducer } from 'redux-act';
import actions from '../actions/otherAttendanceActions';

const initialState = {
  selfAttendancePending: false,
  selfAttendanceRes: null,
  selfAttendanceError: null,

  myTeamAttendancePending: false,
  myTeamAttendanceRes: null,
  myTeamAttendanceError: null,

  allTeamAttendancePending: false,
  allTeamAttendanceRes: null,
  allTeamAttendanceError: null,

  attendanceReportPending: false,
  attendanceReportRes: null,
  attendanceReportError: null,

    getDepartmentWiseAttendancePending: false,
  getDepartmentWiseAttendanceRes: null,
  getDepartmentWiseAttendanceError: null,

  getAllEmployeeAttendancePending: false,
  getAllEmployeeAttendanceRes: null,
  getAllEmployeeAttendanceError: null,

};
/* Self Attendance Reducers */
const handleSelfAttendanceRequest = state => {
  return {
    ...state,
    ...{
      selfAttendancePending: true,
      selfAttendanceRes: null,
      selfAttendanceError: null,
    },
  };
};
const handleSelfAttendanceSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      selfAttendancePending: false,
      selfAttendanceRes: payload,
      selfAttendanceError: null,
    },
  };
};
const handleSelfAttendanceError = (state, payload) => ({
  ...state,
  ...{
    selfAttendancePending: false,
    selfAttendanceRes: null,
    selfAttendanceError: payload,
  },
});


/* My Team Attendance Reducers */
const handleMyTeamAttendanceRequest = state1 => {
  return {
    ...state1,
    ...{
      myTeamAttendancePending: true,
      myTeamAttendanceRes: null,
      myTeamAttendanceError: null,
    },
  };
};
const handleMyTeamAttendanceSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      myTeamAttendancePending: false,
      myTeamAttendanceRes: payload,
      myTeamAttendanceError: null,
    },
  };
};
const handleMyTeamAttendanceError = (state1, payload) => ({
  ...state1,
  ...{
    myTeamAttendancePending: false,
    myTeamAttendanceRes: null,
    myTeamAttendanceError: payload,
  },
});

/* All Team Attendance Reducers */
const handleAllTeamAttendanceRequest = state1 => {
  return {
    ...state1,
    ...{
      allTeamAttendancePending: true,
      allTeamAttendanceRes: null,
      allTeamAttendanceError: null,
    },
  };
};
const handleAllTeamAttendanceSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      allTeamAttendancePending: false,
      allTeamAttendanceRes: payload,
      allTeamAttendanceError: null,
    },
  };
};
const handleAllTeamAttendanceError = (state1, payload) => ({
  ...state1,
  ...{
    allTeamAttendancePending: false,
    allTeamAttendanceRes: null,
    allTeamAttendanceError: payload,
  },
});

/*  Attendance Report Reducers */
const handleAttendanceReportRequest = state1 => {
  return {
    ...state1,
    ...{
      attendanceReportPending: true,
      attendanceReportRes: null,
      attendanceReportError: null,
    },
  };
};
const handleAttendanceReportSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      attendanceReportPending: false,
      attendanceReportRes: payload,
      attendanceReportError: null,
    },
  };
};
const handleAttendanceReportError = (state1, payload) => ({
  ...state1,
  ...{
    attendanceReportPending: false,
    attendanceReportRes: null,
    attendanceReportError: payload,
  },
});

/*  Attendance Report Reducers */
const handleGetDepartmentWiseAttendanceRequest = state1 => {
  return {
    ...state1,
    ...{
      getDepartmentWiseAttendancePending: true,
      getDepartmentWiseAttendanceRes: null,
      getDepartmentWiseAttendanceError: null,
    },
  };
};
const handleGetDepartmentWiseAttendanceSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getDepartmentWiseAttendancePending: false,
      getDepartmentWiseAttendanceRes: payload,
      getDepartmentWiseAttendanceError: null,
    },
  };
};
const handleGetDepartmentWiseAttendanceError = (state1, payload) => ({
  ...state1,
  ...{
    getDepartmentWiseAttendancePending: false,
    getDepartmentWiseAttendanceRes: null,
    getDepartmentWiseAttendanceError: payload,
  },
});


/*  Attendance Report Reducers */
const handleGetAllEmployeeAttendanceRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllEmployeeAttendancePending: true,
      getAllEmployeeAttendanceRes: null,
      getAllEmployeeAttendanceError: null,
    },
  };
};
const handleGetAllEmployeeAttendanceSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllEmployeeAttendancePending: false,
      getAllEmployeeAttendanceRes: payload,
      getAllEmployeeAttendanceError: null,
    },
  };
};
const handleGetAllEmployeeAttendanceError = (state1, payload) => ({
  ...state1,
  ...{
    getAllEmployeeAttendancePending: false,
    getAllEmployeeAttendanceRes: null,
    getAllEmployeeAttendanceError: payload,
  },
});

// Clear Existing Data Store Reducers*/
const clearOtherAttendanceStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_ADD_DEPARTMENT_STORE':
      return {
        ...state,
        ...{
          selfAttendancePending: false,
          selfAttendanceRes: null,
          selfAttendanceError: null,
        },
      };
    case 'HANDLE_CLEAR_ATTENDANCE_REPORT_STORE':
      return {
        ...state,
        ...{
          attendanceReportPending: false,
          attendanceReportRes: null,
          attendanceReportError: null,
        },
      };
    default:
      return state;
  }
};



export default createReducer(
  {
    [actions.selfAttendanceRequest]: handleSelfAttendanceRequest,
    [actions.selfAttendanceSuccess]: handleSelfAttendanceSuccess,
    [actions.selfAttendanceError]: handleSelfAttendanceError,

    [actions.myTeamAttendanceRequest]: handleMyTeamAttendanceRequest,
    [actions.myTeamAttendanceSuccess]: handleMyTeamAttendanceSuccess,
    [actions.myTeamAttendanceError]: handleMyTeamAttendanceError,

    [actions.allTeamAttendanceRequest]: handleAllTeamAttendanceRequest,
    [actions.allTeamAttendanceSuccess]: handleAllTeamAttendanceSuccess,
    [actions.allTeamAttendanceError]: handleAllTeamAttendanceError,

    [actions.attendanceReportRequest]: handleAttendanceReportRequest,
    [actions.attendanceReportSuccess]: handleAttendanceReportSuccess,
    [actions.attendanceReportError]: handleAttendanceReportError,

    
    [actions.getDepartmentWiseAttendanceRequest]: handleGetDepartmentWiseAttendanceRequest,
    [actions.getDepartmentWiseAttendanceSuccess]: handleGetDepartmentWiseAttendanceSuccess,
    [actions.getDepartmentWiseAttendanceError]: handleGetDepartmentWiseAttendanceError,

    [actions.getAllEmployeeAttendanceRequest]: handleGetAllEmployeeAttendanceRequest,
    [actions.getAllEmployeeAttendanceSuccess]: handleGetAllEmployeeAttendanceSuccess,
    [actions.getAllEmployeeAttendanceError]: handleGetAllEmployeeAttendanceError,

    [actions.handleClearOtherAttendanceStore]: clearOtherAttendanceStore,
  },
  initialState,
);